import { render } from "./CardPagination.vue?vue&type=template&id=0721cbb7"
import script from "./CardPagination.vue?vue&type=script&lang=js"
export * from "./CardPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__